
































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class DownloadProgressToast extends Vue {
  @Prop({ default: false }) visible!: boolean;
  @Prop({ default: '' }) filename!: string;
  @Prop({ default: 0 }) progress!: number;
  @Prop({ default: 0 }) downloadedBytes!: number;
  @Prop({ default: 0 }) totalBytes!: number;
  @Prop({ default: 0 }) speed!: number; // bytes per second
  @Prop({ default: false }) completed!: boolean;
  
  get downloadedMB(): string {
    return (this.downloadedBytes / 1024 / 1024).toFixed(2);
  }
  
  get totalMB(): string {
    return (this.totalBytes / 1024 / 1024).toFixed(2);
  }
  
  get progressPercent(): string {
    return Math.round(this.progress).toString();
  }
  
  get speedMBps(): string {
    return (this.speed / 1024 / 1024).toFixed(2);
  }
  
  get remainingTime(): number {
    if (this.speed === 0) return 0;
    const remainingBytes = this.totalBytes - this.downloadedBytes;
    return Math.round(remainingBytes / this.speed);
  }
  
  get timeRemaining(): string {
    const minutes = Math.floor(this.remainingTime / 60);
    const seconds = this.remainingTime % 60;
    if (minutes > 0) {
      return `${minutes}m ${seconds}s restant`;
    }
    return `${seconds}s restant`;
  }
}
